import { css } from '@emotion/react';
import { breakpoints, flex, margins, paddings, themed } from '@spotnana/blocks/src/utils';

export const checkout_page_container = css`
  padding: 40px auto;
`;

export const checkout_title_container = themed(
  ({ palette }) => css`
    background: ${palette.surface.base};
    ${paddings.y.p2}

    ${breakpoints.from('tablet')} {
      ${paddings.x.p2}
    }
  `,
);

export const title_accessory = css`
  ${margins.xl.m2}
`;
export const checkout_content_background = themed(
  ({ palette }) => css`
    background: ${palette.surface.background};
    ${paddings.y.p2}
  `,
);

export const checkout_content_container = css`
  position: relative;
  ${flex.init}
  ${flex.wrap.wrap}
  ${paddings.x.p1}
  ${paddings.y.p1}

  ${breakpoints.from('desktop')} {
    ${flex.wrap.noWrap}
  }
  ${breakpoints.from('tablet')} {
    ${paddings.x.p2}
  }
`;

export const back_button = css`
  margin-left: -0.75rem;
`;
